import React from "react"
import {
  CalendarEventAvailabilityDay,
  CalendarEventAvailabilitySlot,
} from "../../../../../api/backend/backend-api"
import { BackArrowIcon } from "../../../../../ui/icons"
import CustomCalendarButton from "../../../../../ui/organisms/CustomCalendar/CustomCalendarButton"
import {
  getCalendarDayName,
  getMonthName,
} from "../../../../../ui/organisms/CustomCalendar/utils"
import EventCalendarTimeButton from "../EventCalendarTimeButton"
import classes from "./EventCalendarDayHours.module.css"

interface Props {
  day: CalendarEventAvailabilityDay
  selected?: CalendarEventAvailabilitySlot
  onSelectedChanged: (slot: CalendarEventAvailabilitySlot) => void
  onConfirm: (slot: CalendarEventAvailabilitySlot) => void
  onBack: () => void
  backHidden?: boolean
}

const getDayTitle = (day: CalendarEventAvailabilityDay) =>
  `${getCalendarDayName(day)}, ${day.day} ${getMonthName(day)}`

const isSelected = (
  x: CalendarEventAvailabilitySlot,
  selected?: CalendarEventAvailabilitySlot
) =>
  selected &&
  selected.from.hour === x.from.hour &&
  selected.from.minute === x.from.minute

const EventCalendarDayHours = ({
  day,
  selected,
  onSelectedChanged,
  onConfirm,
  onBack,
  backHidden,
}: Props) => {
  return (
    <div className={classes.root}>
      {!backHidden && (
        <div className={classes.back}>
          <CustomCalendarButton onClick={onBack} withBackground>
            <BackArrowIcon />
          </CustomCalendarButton>
        </div>
      )}
      <div className={classes.title}>{getDayTitle(day)}</div>
      <div className={`customScrollbar ${classes.items}`}>
        {day.slots.map((x, index) => (
          <EventCalendarTimeButton
            key={index}
            className="mb-2"
            onConfirm={() => onConfirm(x)}
            onSelect={() => onSelectedChanged(x)}
            slot={x}
            selected={isSelected(x, selected)}
          />
        ))}
      </div>
    </div>
  )
}

export default EventCalendarDayHours
